
import Paper from './paper.vue'
import PaperSubject from './paperSubject.vue'
export default {
	Paper,
  PaperSubject
}


// WEBPACK FOOTER //
// ./src/views/testPaper/index.js